module.exports = __webpack_public_path__ + "static/media/iconmonstr-arrow-24.26fe0a89.svg";